import { routes } from '@/domains/core/routing/routes/routes.default';

export const CART_URL = routes.cart;
